module.exports = __webpack_public_path__ + "media/components/src/assets/images/gift-card/gift-card-464156adf3372d6cacf2d446a2942d30.svg";